$(document).ready(function(){
    function viewWarningAlert(message) {
        $.smallBox({
            content: message,
            color: "#C46A69",
            timeout: 20000,
            icon: "fa fa-warning shake animated"
        });
    }

    function viewSuccessAlert(message) {
        $.smallBox({
            content: message,
            color: "#739E73",
            timeout: 8000,
            icon: "fa fa-bell swing animated"
        });
    }

    $('input[type="checkbox"][name="CustomersWorkers[id]"]').change(function () {
        var $elem = $(this);

        var url = $elem.prop('checked')
            ? '/customers/apply'
            : '/customers/cancel';

        var id = $elem.val();

        $.ajax({
            url: url,
            type: 'POST',
            data: {
                id: id,
                YII_CSRF_TOKEN: token
            }
        }).done(function (response) {
            if (response.code == 0) {
                viewSuccessAlert(response.response.message)
            } else {
                viewWarningAlert(response.response.message)
            }
        });
    });

});